var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "-12.915%",
    x2: "169.73%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7190C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#031266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C466C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D27497"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.158,
    height: 20,
    x: 0.042,
    fill: "url(#prefix__a)",
    rx: 1.016
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    stroke: "#89489B",
    strokeWidth: 0.7,
    d: "M14.6 5.4c2.872 0 5.2 2.328 5.2 5.2 0 1.222-.42 2.345-1.126 3.232l3.766 3.802c.31.313.309.818-.003 1.129l-.565.566c-.313.312-.82.312-1.132 0l-.002-.003-3.965-4c-.66.304-1.397.474-2.173.474-2.871 0-5.2-2.328-5.2-5.2 0-2.872 2.329-5.2 5.2-5.2z",
    opacity: 0.816
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyDetails);
export default __webpack_public_path__ + "static/media/policy-details.dc38b486e7f2c0db2566d0cf34ccd2a5.svg";
export { ForwardRef as ReactComponent };